$(document).ready(function(){
    updateCartAJAX();

    if(jQuery('.manyVariants').length) {
        jQuery('.variantAdd2Cart').click(function(e){
            
            e.preventDefault();
            var id = $(this).parent().find('.hiddenId').val();
            var qty = $(this).parent().find('.product-form__input--quantity').val();

            jQuery('.product-form-product-template #ProductSelect-product-template').val(id);
            jQuery('.product-form-product-template .product-form__input--quantity').val(qty);

            $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: $('.product-form-product-template').serialize(),
                success: function() {
                    updateCartAJAX();
                    setTimeout($('body, .cart-sidebar').addClass('open'), 1000)
                    
                }
             });
        })
    }

    if($('.template-product').length && !jQuery('.manyVariants').length) {
        jQuery('.product-form__cart-submit').click(function(e){
            setTimeout(function() {
            updateCartAJAX();
            $('body, .cart-sidebar').addClass('open');

            }, 2500);

        })   
    }
});

$('.hide_shipping_modal').on('click', function (e) {
    $('body, .shipping-selector-sidebar').removeClass('open');
    e.preventDefault();
});

$('.cart-icon-header').on('click', function (e) {
    $('body, .cart-sidebar').toggleClass('open');
    e.preventDefault();
});

$('.cart-icon-header .close').on('click', function (e) {
    $('body,.cart-sidebar').removeClass('open');
    e.preventDefault();
});

$('.continue_shopping').on('click', function (e) {
    $('body,.cart-sidebar').removeClass('open');
    e.preventDefault();
});

$('.subscription_bar_close').on('click', function(){
    $('.subscription_wrapper').slideUp('slow');
});

$(document).on("click", function(evt){
    const flyoutElement = document.getElementById("shipping-selector-sidebar");
    let targetElement = evt.target; // clicked element
    const clickedElem = evt.target;
    const clickedElemClasses = evt.target.classList.toString();

    do {
        if (targetElement == flyoutElement) {
            return;
        }
        // Go up the DOM
        targetElement = targetElement.parentNode;
    } while (targetElement);

    if(clickedElemClasses.includes('shipping_selector_img')){
        $('body, .shipping-selector-sidebar').addClass('open');
        evt.preventDefault();
    } else {
        $('body, .shipping-selector-sidebar').removeClass('open');
    }
});


$(document).on("click", function(e){

    if(!$( e.target ).hasClass('continue_shopping') && (document.getElementById("sideCart").contains(e.target) || $( e.target ).hasClass('cart-icon-header') || $( e.target ).hasClass('cart')) ){
        $('.cart-sidebar').addClass('open');
    } else {
        $('.cart-sidebar').removeClass('open');
    }
});



$('.ajaxAddToCart, .ajaxAddToCart > img').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    var elem = $(this);

    var prodId = $(this).attr('data-productid');
    var qty = $(this).attr('data-qty');

    addItem(prodId, qty);
});

function updateCartAJAX() {
    $.get('/cart?view=json', function(result) {
        var cart = JSON.parse(result);
        
        $('.site-header__cart-count .catQty').text(cart.item_count);
        $('.drawer_subtotal').html(cart.subtotal);
        $('.drawer_total').html(cart.total);

        // console.log(cart);
        var sdul = '';

        $.each(cart.items,function(i,item) {
            var url = item['url'];
            if(url.indexOf('-1') !== -1) {
                url = url.substring(0, url.indexOf("-1"));
            }
            if(url.indexOf('-2') !== -1) {
                url = url.substring(0, url.indexOf("-2"));
            }

            var div = "<div class='item'>";
                div += "<div class='remove-wrapper'>";
                    div += "<a href='javascript:void(0);' class='remove_item' data-variant='"+item["variant_id"]+"'>";
                        div += "<img src='//threesbrewing.com/cdn/shop/t/135/assets/remove_icon.svg?v=100453865931529412321785360508' alt='Remove' />";
                    div += "</a>";
                div += "</div>";
                div += "<div class='image'>";
                    div += "<img src='"+item["image"]+"' alt='"+item["title"]+"' />";
                div += "</div>";
                div += "<div class='details'>";
                    div += "<a href='"+url+"' class='title'>"+item['title']+"</a>";
                    div += "<div class='subtitle'>"+item['subtitle']+"</div>";
                    if(item['variant_title'] !== null){
                        div += "<div class='variant'>"+item['variant_title']+"</div>";
                    }
                div += "</div>";
                div += "<div class='qty-container'>";
                    div += "<div class='qty_wrapper cart_quantity'>";
                        div += "<a href='javascript:void(0);' class='qty_minus' data-variant='"+item["variant_id"]+"'>";
                            div += "<img src='//threesbrewing.com/cdn/shop/t/135/assets/minus_icon.svg?v=133187493767968418911785360493' alt='Minus' />";
                        div += "</a>";
                        div += "<span class='quantity' data-qty='"+item["quantity"]+"'>"+item['quantity']+"</span>";
                        div += "<a href='javascript:void(0);' class='qty_plus' data-variant='"+item["variant_id"]+"'>";
                            div += "<img src='//threesbrewing.com/cdn/shop/t/135/assets/plus_icon.svg?v=51065998742542438421785360506' alt='Plus' />";
                        div += "</a>";
                    div += "</div>";
                div += "</div>";
                div += "<div class='price_wrapper'>";
                    div += "<div class='price'>$"+parseFloat(item['quantity']*item['price']/100).toFixed(0)+"</div>";
                div += "</div>";
            div += "</div>"; 
            sdul += div;
        });

        
        $('#cart-items').html(sdul);

        // Beer landing page cart icon
        var cartIconLanding = document.querySelectorAll('.cart-icon-wrapper')

        if(cart.item_count == 0){
            $('.cart-body').addClass('empty');
            $('.empty_cart').show();

            if (cartIconLanding.length) {
                cartIconLanding.forEach(function(el) {
                    el.firstElementChild.setAttribute('fill', 'none');
                    el.parentElement.classList.add('empty');
                })
            }
        } else {
            $('.cart-body').removeClass('empty');
            $('.empty_cart').hide();

            if (cartIconLanding.length) {
                cartIconLanding.forEach(function(el) {
                  el.firstElementChild.setAttribute('fill', 'rgb(104, 195, 232)');
                  el.parentElement.classList.remove('empty');
                })
            }
        }

    });
}

function addItem(productid, qty) {
    var prodId = productid;

    newItemData = {
        quantity: qty,
        id: prodId
    }

    $.post('/cart/add.js', newItemData, function(data,status,xhr) {
        if(status=="success") {
            updateCartAJAX();
        }
    });
}

function updateItem(productid, quantity) {
    var prodId = productid;

    newItemData = {
        quantity: quantity,
        id: prodId
    }

    $.post('/cart/change.js', newItemData, function(data,status,xhr) {
        if(status=="success") {
            updateCartAJAX();
        }
    });
}

function removeItem(productid) {
    var prodId = productid;

    newItemData = {
        quantity: 0,
        id: prodId
    }

    $.post('/cart/change.js', newItemData, function(data,status,xhr) {
        if(status=="success") {
            updateCartAJAX();
        }
    });
}

$("body").delegate('.remove_item', "click", function(e) {
    e.preventDefault();
    var productId = $(this).data('variant');
    removeItem(productId);
});

$("body").delegate('.cart_quantity .qty_minus, .cart_quantity .qty_plus', "click", function(e) {
    e.preventDefault();
    
    var productId = $(this).data('variant');
    var current_quantity = $(this).siblings('.quantity').data('qty');

    if($(this).hasClass('qty_plus')) {
        updateItem(productId, current_quantity + 1);
    } else {
        updateItem(productId, current_quantity - 1);
    }
});



/* Nisha's code for abotu US page */

$(document).ready(function(){
    if($('.template-page').length) {
        $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
          ) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 1000, function() {
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) {
                  return false;
                } else {
                  $target.attr('tabindex','-1');
                  $target.focus();
                };
              });
            }
          }
        });
    }

});